import { SidebarLink } from 'types/sidebar'

import {
  PAGE_AGGREGATOR_API_LOG,
  PAGE_AGGREGATOR_MANAGEMENT,
  PAGE_CONFIG,
  PAGE_ERP_API_LOGS,
  PAGE_FTP_CONFIG,
  PAGE_FTP_CREATION_LOGS,
  PAGE_FUNC_JOBS,
  PAGE_IMPORT_LOGS,
  PAGE_INVENTORY,
  PAGE_MASTER_DATA,
  PAGE_PRICING,
  // PAGE_STORE_ORDERS,
  PAGE_ADMIN_ORDERS,
  PAGE_POS_API_LOGS,
  PAGE_SMART_OOS,
  PAGE_STORE_MGMT,
  PAGE_USER_MGMT,
  PAGE_EXPORT_LOGS,
  PAGE_ORDERS_LOGS,
  PAGE_RECONCILIATION_LOGS,
} from './pages'

import {
  BagIcon,
  AggregatorIcon,
  FtpConfigurationIcon,
  DashboardIcon,
  LogIcon,
  SmartOosIcon,
  SettingsIcon,
  StoreIcon,
  UserIcon,
} from 'components/icons'

export const SIDEBAR_LINKS: SidebarLink[] = [
  // { ...PAGE_STORE_ORDERS, icon: BagIcon },
  {
    id: 'DASHBOARD',
    name: 'Dashboard',
    icon: DashboardIcon,
    children: [
      PAGE_MASTER_DATA,
      PAGE_INVENTORY,
      PAGE_PRICING,
      PAGE_ADMIN_ORDERS,
    ],
  },
  {
    ...PAGE_SMART_OOS,
    icon: SmartOosIcon,
  },
  {
    ...PAGE_FUNC_JOBS,
    icon: BagIcon,
  },
  {
    id: 'LOGS',
    name: 'Logs',
    icon: LogIcon,
    children: [
      PAGE_ERP_API_LOGS,
      PAGE_POS_API_LOGS,
      PAGE_FTP_CREATION_LOGS,
      PAGE_AGGREGATOR_API_LOG,
      PAGE_IMPORT_LOGS,
      PAGE_EXPORT_LOGS,
      PAGE_ORDERS_LOGS,
      PAGE_RECONCILIATION_LOGS,
    ],
  },
  {
    ...PAGE_CONFIG,
    icon: SettingsIcon,
  },
  {
    ...PAGE_USER_MGMT,
    icon: UserIcon,
  },
  {
    ...PAGE_STORE_MGMT,
    icon: StoreIcon,
  },
  {
    ...PAGE_AGGREGATOR_MANAGEMENT,
    icon: AggregatorIcon,
  },
  {
    ...PAGE_FTP_CONFIG,
    icon: FtpConfigurationIcon,
  },
]
